import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="outlet-matrix"
export default class extends Controller {
  static targets = ["input", "item", "checkbox", "empty", "selectedCount", "visibleCount", "totalCount", "summary"]

  connect() {
    this.filter()
    this.update()
  }

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ""
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const searchText = item.dataset.searchText || item.dataset.name || ""
      const visible = query === "" || searchText.toLowerCase().includes(query)

      item.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    this.update()
  }

  selectAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      if (this.visibleCheckbox(checkbox)) {
        checkbox.checked = true
      }
    })
    this.update()
  }

  clearAll(event) {
    event.preventDefault()
    this.checkboxTargets.forEach(checkbox => {
      if (this.visibleCheckbox(checkbox)) {
        checkbox.checked = false
      }
    })
    this.update()
  }

  toggle() {
    this.update()
  }

  clearSearch(event) {
    event.preventDefault()
    if (this.hasInputTarget) this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }  update() {
    const selectedCount = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    const visibleCount = this.itemTargets.filter(item => !item.classList.contains("hidden")).length
    const totalCount = this.checkboxTargets.length

    const countEl = document.getElementById("selected-outlets-count")
    if (countEl) countEl.textContent = selectedCount

    const totalEl = document.getElementById("total-outlets-count")
    if (totalEl) totalEl.textContent = totalCount

    const summaryEl = document.getElementById("selected-outlets-summary")
    if (summaryEl) {
      summaryEl.textContent = selectedCount === totalCount ? "All outlets selected" : `${selectedCount} of ${totalCount} outlets selected`
    }

    if (this.hasSelectedCountTarget) this.selectedCountTarget.textContent = selectedCount
    if (this.hasVisibleCountTarget) this.visibleCountTarget.textContent = visibleCount
    if (this.hasTotalCountTarget) this.totalCountTarget.textContent = totalCount

    if (this.hasSummaryTarget) {
      this.summaryTarget.textContent = selectedCount === totalCount ? "All outlets selected" : `${selectedCount} of ${totalCount} outlets selected`
    }

    this.itemTargets.forEach(item => {
      const checkbox = item.querySelector("input[type='checkbox']")
      item.classList.toggle("border-brand-yellow", checkbox?.checked)
      item.classList.toggle("bg-brand-yellow/10", checkbox?.checked)
      item.classList.toggle("border-transparent", !checkbox?.checked)
      item.classList.toggle("bg-white", !checkbox?.checked)
    })
  }
  visibleCheckbox(checkbox) {
    return !checkbox.closest('[data-outlet-matrix-target="item"]').classList.contains("hidden")
  }
}
